export const projects = [
  {
    id: 1,
    title: {
      tr: "Cooking Craft Clone",
      en: "Cooking Craft Clone"
    },
    description: {
      tr: "Cooking Craft Clone, makineler yardımıyla yiyecek hazırlayıp müşterilere teslim edilen bir mobil oyundur.",
      en: "Cooking Craft Clone is a mobile game where you prepare food with machines and deliver it to customers."
    },
    image: "/images/Cooking Craft/1702494888636.jpg",
    date: "2023-01-01",
    technologies: ["Unity", "C#", "Mobil Oyun", "UI/UX"],
    gallery: [
      "/images/Cooking Craft/1702494888636.jpg",
      "/images/Cooking Craft/1702494901020.jpg",
      "/images/Cooking Craft/1702494917649.jpg",
      "/images/Cooking Craft/1702494935092.jpg"
    ],
    longDescription: {
      tr: `Cooking Craft Clone, oyun geliştirme yolculuğuma sıfır deneyimle başladığım ve bilgi birikimimi oluşturduğum ilk projedir. Bu oyun, sadece bir oyun değil, aynı zamanda bir öğrenme ve gelişim süreciydi. Programlama dilleri, grafik tasarım, oyun motorları ve kullanıcı arayüzü tasarımı gibi alanlarda kendimi geliştirdim. Küçük bir ekiple çalışarak iletişim ve iş birliği becerilerimi artırdım. Proje yönetimi, stratejik planlama ve geliştirme sürecini takip etme konularında deneyim kazandım. Bu proje sayesinde edindiğim güçle, gelecekte daha büyük ve yenilikçi projeler üretmeye kararlıyım.`,
      en: `Cooking Craft Clone is the first project where I started my game development journey with zero experience and built my own knowledge base. This game was not only a game but also a process of learning and development. I constantly improved myself in areas such as programming languages, graphic design, game engines, and user interface design. By working in a small team, I increased my communication and collaboration skills. I gained experience in project management, taking a strategic approach to planning, prioritizing, and tracking the development process. With the strength I gained from this project, I am determined to create bigger and more innovative projects in the future.`
    },
    videoUrl: "https://youtu.be/86Wls4yKcks",
    details: {
      geliştirmeSüresi: {
        tr: "2 ay",
        en: "2 months"
      },
      platform: "Mobil",
      durumu: {
        tr: "Tamamlandı",
        en: "Completed"
      },
      ekipBüyüklüğü: {
        tr: "3 kişi",
        en: "3 people"
      },
      roller: {
        tr: ["Oyun Tasarımı", "Programlama", "UI/UX", "Proje Yönetimi"],
        en: ["Game Design", "Programming", "UI/UX", "Project Management"]
      },
      özellikler: {
        tr: [
          "Modüler sistemler",
          "Takım içi iletişim ve iş birliği",
          "Unity ile ilk deneyim"
        ],
        en: [
          "Modular systems",
          "Team communication and collaboration",
          "First experience with Unity"
        ]
      }
    },
    gameUrl: ""
  },
  {
    id: 2,
    title: {
      tr: "Bum Bum Monsterz",
      en: "Bum Bum Monsterz"
    },
    description: {
      tr: "Unity ile geliştirilmiş 3D party oyunu. Bıngıl Bıngıl eğlence.",
      en: "3D party game developed with Unity. Bouncy fun."
    },
    image: "/images/Bum Bum Monsterz/Bumheader.jpg",
    date: "2024-11-27",
    technologies: ["Unity", "C#"],
    gallery: [
      "/images/Bum Bum Monsterz/Bum1.jpg",
      "/images/Bum Bum Monsterz/Bum2.jpg",
      "/images/Bum Bum Monsterz/Bum3.jpg",
      "/images/Bum Bum Monsterz/Bum4.jpg",
      "/images/Bum Bum Monsterz/Bum5.jpg",
    ],
    longDescription: {
      tr: "Bum Bum Monsterz, 2v2'den 4v4'e kadar oynanabilen takım tabanlı çok oyunculu bir parti oyunudur. Arkadaşlarınızı gırgır dolu mücadelelere girin, absürt engellerle başa çıkmaya çalışın ve eğlenceli bulmacalar çözün. Canlı grafikler ve renkli karakterlerle bıngıl bıngıl bir maceraya hazır mısınız?",
      en: "Bum Bum Monsterz is a team-based multiplayer party game that can be played from 2v2 to 4v4. Get into hilarious challenges with your friends, try to cope with absurd obstacles, and solve fun puzzles. Are you ready for a bouncy adventure with vibrant graphics and colorful characters?"
    },
    videoUrl: "https://www.youtube.com/embed/Z8L_kzEPoxg",
    details: {
      geliştirmeSüresi: {
        tr: "5 ay",
        en: "5 months"
      },
      platform: "PC",
      durumu: {
        tr: "Erken Erişim",
        en: "Early Access"
      },
      ekipBüyüklüğü: "-",
      roller: {
        tr: ["Bug Fix", "Programlama"],
        en: ["Bug Fix", "Programming"]
      },
      özellikler: {
        tr: [
          "Çoklu oyuncu desteği",
          "Özelleştirilebilir karakterler"
        ],
        en: [
          "Multiplayer support",
          "Customizable characters"
        ]
      }
    },
    gameUrl: "https://store.steampowered.com/app/2071400/Bum_Bum_Monsterz/"
  },
  {
    id: 3,
    title: {
      tr: "Dream Diver",
      en: "Dream Diver"
    },
    description: {
      tr: "Unity ile geliştirilmiş 3D FPS gamejam oyunu",
      en: "3D FPS gamejam game developed with Unity"
    },
    image: "/images/Dream Diver/1.jpg",
    date: "2023-08-27",
    technologies: ["Unity", "C#"],
    gallery: [
      "/images/Dream Diver/1.jpg",
      "/images/Dream Diver/2.jpg",
      "/images/Dream Diver/3.jpg",
      "/images/Dream Diver/4.jpg",
      "/images/Dream Diver/5.jpg",
      "/images/Dream Diver/6.jpg",
    ],
    longDescription: {
      tr: "Dream Diver, Konusu derine dalmak olan bir Brackeys Game Jam 2023.2 oyunudur. Oyunun amacı, rüyalarda derinlere dalarak düşmanları yok etmektir.",
      en: "Dream Diver is a Brackeys Game Jam 2023.2 game with the theme of diving deep. The goal of the game is to dive deep into dreams and eliminate enemies."
    },
    videoUrl: "https://www.youtube.com/embed/xSnDiETzB9I",
    details: {
      geliştirmeSüresi: {
        tr: "1 hafta",
        en: "1 week"
      },
      platform: "PC",
      durumu: {
        tr: "Tamamlandı",
        en: "Completed"
      },
      ekipBüyüklüğü: {
        tr: "3 kişi",
        en: "3 people"
      },
      roller: {
        tr: ["Oyun Tasarımı", "Programlama", "UI/UX", "Level Design"],
        en: ["Game Design", "Programming", "UI/UX", "Level Design"]
      },
      özellikler: {
        tr: [
          "FPS oyun mekanikleri",
          "Düşman yapay zekası"
        ],
        en: [
          "FPS game mechanics",
          "Enemy AI"
        ]
      }
    },
    gameUrl: "https://emircanisanc.itch.io/dream-diver"
  },
  {
    id: 4,
    title: {
      tr: "Lava Parkour: Muhittin's Adventure",
      en: "Lava Parkour: Muhittin's Adventure"
    },
    description: {
      tr: "Unreal Engine ile geliştirilmiş 3D platform oyunu. Lava parkour mücadelesi",
      en: "3D platform game developed with Unreal Engine. Lava parkour challenge"
    },
    image: "/images/Muhittin/0RwHN.jpg",
    date: "2024-04-30",
    technologies: ["Unreal Engine", "Blueprint", "3D Graphics"],
    gallery: [
      "/images/Muhittin/0RwHN.jpg",
      "/images/Muhittin/6oqZr.jpg"
    ],
    longDescription: {
      tr: "Lava Parkour: Muhittin's Adventure, muhittin adında bir karakterin, lava parkour mücadelesinde hayatta kalmaya çalıştığı bir oyundur.",
      en: "Lava Parkour: Muhittin's Adventure is a game where a character named Muhittin tries to survive in a lava parkour challenge."
    },
    videoUrl: "https://www.youtube.com/embed/wziPQBuIiQw",
    details: {
      geliştirmeSüresi: {
        tr: "1 hafta",
        en: "1 week"
      },
      platform: "PC",
      durumu: {
        tr: "Tamamlandı",
        en: "Completed"
      },
      ekipBüyüklüğü: {
        tr: "1 kişi",
        en: "1 person"
      },
      roller: {
        tr: ["Oyun Tasarımı", "Programlama", "UI/UX"],
        en: ["Game Design", "Programming", "UI/UX"]
      },
      özellikler: {
        tr: [],
        en: []
      }
    },
    gameUrl: "https://irunboss.itch.io/lavaparkour"
  },
  {
    id: 11,
    title: {
      tr: "Digital Preschool",
      en: "Digital Preschool"
    },
    description: {
      tr: "ERASMUS+ kapsamında okul öncesi çocuklar için eğitici ve eğlenceli içerikler sunan, 700 seviye, 150 quiz ve 15 mini oyundan oluşan bir projedir.",
      en: "A project within ERASMUS+ offering educational and entertaining content for preschool children, including 700 levels, 150 quizzes, and 15 mini-games."
    },
    image: "/images/Digital Preschool/Screenshot_2.png",
    date: "2024-02-01",
    technologies: ["Unity", "C#", "Eğitim", "Oyun Tasarımı", "Level Design"],
    gallery: [
      "/images/Digital Preschool/Screenshot_2.png"
    ],
    longDescription: {
      tr: `Digital Preschool, ERASMUS+ kapsamında Türkiye, Slovenya, Estonya ve Litvanya'daki okul öncesi çocuklar için eğitici ve eğlenceli içerikler sunan, 700 seviye, 150 quiz ve 15 mini oyundan oluşan bir projedir. Unity oyun motoru kullanılarak geliştirilen projede, oyun ve level tasarımıyla birlikte geliştirme süreçlerinde aktif olarak görev aldım. Takım yönetimi ve proje yönetimi konularında sorumluluk üstlenerek, ERASMUS+ teşekkür sertifikası kazandım.`,
      en: `Digital Preschool is a project within ERASMUS+ that offers educational and entertaining content for preschool children in Turkey, Slovenia, Estonia, and Lithuania. The project includes 700 levels, 150 quizzes, and 15 mini-games. I actively participated in the development processes, including game and level design, using the Unity game engine. I took responsibility in team and project management, earning an ERASMUS+ certificate of appreciation.`
    },
    caseStudy: {
      problem: {
        tr: "Okul öncesi çocuklar için çok sayıda seviyeyi anlaşılır, tekrar oynanabilir ve farklı yaş gruplarına uygun bir yapıda sunmak gerekiyordu.",
        en: "The project needed to present a large amount of preschool content in a clear, replayable structure suitable for different age groups."
      },
      solution: {
        tr: "Unity üzerinde seviye ve mini oyun akışlarını modüler tuttum; içerik üretimini hızlandıran tasarım kalıpları ve test edilebilir ekran akışları üzerinde çalıştım.",
        en: "I kept the level and mini-game flows modular in Unity, working on repeatable design patterns and testable screen flows that accelerated content production."
      },
      impact: {
        tr: "700 seviye, 150 quiz ve 15 mini oyundan oluşan içerik setinin geliştirme ve teslim sürecinde aktif rol aldım.",
        en: "I actively contributed to the development and delivery of a content set with 700 levels, 150 quizzes, and 15 mini-games."
      }
    },
    videoUrl: "",
    details: {
      geliştirmeSüresi: {
        tr: "6 ay",
        en: "6 months"
      },
      platform: "Web, Mobil",
      durumu: {
        tr: "Tamamlandı",
        en: "Completed"
      },
      ekipBüyüklüğü: {
        tr: "5 kişi",
        en: "5 people"
      },
      roller: {
        tr: ["Oyun Tasarımı", "Level Design", "Proje Yönetimi", "Geliştirme"],
        en: ["Game Design", "Level Design", "Project Management", "Development"]
      },
      özellikler: {
        tr: [
          "700 seviye",
          "150 quiz",
          "15 mini oyun",
          "Unity ile geliştirme",
          "ERASMUS+ iş birliği"
        ],
        en: [
          "700 levels",
          "150 quizzes",
          "15 mini-games",
          "Developed with Unity",
          "ERASMUS+ collaboration"
        ]
      }
    },
    gameUrl: "http://www.digitalpreschools.com/"
  },
  {
    id: 12,
    title: {
      tr: "Project FPS",
      en: "Project FPS"
    },
    description: {
      tr: "Unreal Engine 5 ile sıfırdan geliştirilmiş bir FPS oyunu.",
      en: "A FPS game developed from scratch with Unreal Engine 5."
    },
    image: "/images/FPS project/FPS.png",
    date: "2025-04-01",
    technologies: ["Unreal Engine 5", "Blueprint", "FPS", "Yapay Zeka"],
    gallery: [
      "/images/FPS project/FPS.png"
    ],
    longDescription: {
      tr: `GameDev.tv'nin Unreal Engine 5 Blueprints: First Person Shooter (FPS) kursunu temel alarak, Unreal Engine 5 kullanımıyla sıfırdan geliştirdiğim bir FPS oyunu. Blueprint sisteminden faydalanarak karakter kontrolü, silah mekanikleri, mermi sistemi ve yapay zekâ düşman davranışlarını başarıyla entegre ettim. Bu proje, Unreal Engine 5 üzerindeki teknik becerilerimi geliştirirken oyun içi sistemleri tasarlama ve uygulama konusunda pratik deneyim kazanmamı sağladı.`,
      en: `Based on GameDev.tv's Unreal Engine 5 Blueprints: First Person Shooter (FPS) course, this is a FPS game I developed from scratch using Unreal Engine 5. I successfully integrated character control, weapon mechanics, bullet system, and AI enemy behaviors using the Blueprint system. This project helped me improve my technical skills on Unreal Engine 5 and gain practical experience in designing and implementing in-game systems.`
    },
    caseStudy: {
      problem: {
        tr: "FPS prototipinde karakter kontrolü, silah kullanımı, mermi davranışı ve düşman tepkilerini tek oynanabilir döngüde toplamak gerekiyordu.",
        en: "The FPS prototype needed to combine character control, weapon handling, projectile behavior, and enemy responses into a playable loop."
      },
      solution: {
        tr: "Blueprint tabanlı sistemlerle ateş etme, hasar alma/verme, AI davranışı ve oyuncu geri bildirimlerini ayrıştırılmış modüller halinde kurdum.",
        en: "I used Blueprint-based systems to structure shooting, damage, AI behavior, and player feedback as separated modules."
      },
      impact: {
        tr: "UE5 içinde FPS gameplay akışını uçtan uca kurarak sonraki Unreal projeleri için yeniden kullanılabilir bir teknik temel oluşturdum.",
        en: "I built an end-to-end FPS gameplay flow in UE5 and created a reusable technical base for later Unreal projects."
      }
    },
    videoUrl: "https://www.youtube.com/embed/5QMfzjfUL3Y",
    details: {
      geliştirmeSüresi: {
        tr: "1 ay",
        en: "1 month"
      },
      platform: "PC",
      durumu: {
        tr: "Tamamlandı",
        en: "Completed"
      },
      ekipBüyüklüğü: {
        tr: "1 kişi",
        en: "1 person"
      },
      roller: {
        tr: ["Oyun Tasarımı", "Programlama", "Blueprint", "Geliştirme"],
        en: ["Game Design", "Programming", "Blueprint", "Development"]
      },
      özellikler: {
        tr: [
          "Karakter kontrolü",
          "Silah ve mermi sistemi",
          "Yapay zekâ düşmanlar",
          "Blueprint ile geliştirme"
        ],
        en: [
          "Character control",
          "Weapon and bullet system",
          "AI enemies",
          "Developed with Blueprint"
        ]
      }
    },
    gameUrl: ""
  },
  {
    id: 13,
    title: {
      tr: "TPS Combat Prototype",
      en: "TPS Combat Prototype"
    },
    description: {
      tr: "Unreal Engine 5 ve C++ ile geliştirilmiş TPS (Third Person Shooter) savaş prototipi.",
      en: "TPS (Third Person Shooter) combat prototype developed with Unreal Engine 5 and C++."
    },
    image: "/images/TPS COMBAT/Screenshot_1.png",
    date: "2025-02-01",
    technologies: ["Unreal Engine 5", "C++", "Blueprint", "AI", "Animation"],
    gallery: [
      "/images/TPS COMBAT/Screenshot_1.png"
    ],
    longDescription: {
      tr: `Unreal Engine 5'te C++ temelli geliştirme pratiği kazanmak amacıyla, Sebilgi YouTube kanalındaki eğitim içeriklerini takip ederek TPS (Third Person Shooter) tabanlı bir karakter kontrol ve savaş sistemi geliştirdim. Bu projede hem animasyon entegrasyonu hem de temel dövüş mekanikleri üzerine yoğunlaştım. C++ ile geliştirdiğim bu projede karakter saldırı kombinasyonları, düşman AI mantığı ve hasar sistemleri gibi savaş odaklı mekanikleri uyguladım. Blueprint ve C++'ı birlikte kullanarak esnek ve genişletilebilir bir sistem oluşturdum. Kod optimizasyonu, hata ayıklama, oyun içi test senaryoları ve prototip geliştirme süreçlerinde deneyim kazandım.`,
      en: `To gain C++ development practice in Unreal Engine 5, I followed Sebilgi YouTube channel's tutorials and developed a TPS (Third Person Shooter) based character control and combat system. I focused on both animation integration and core combat mechanics. In this project, I implemented combat-focused mechanics such as character attack combos, enemy AI logic, and damage systems using C++. By combining Blueprint and C++, I created a flexible and extensible system. I gained experience in code optimization, debugging, in-game test scenarios, and prototype development processes.`
    },
    caseStudy: {
      problem: {
        tr: "TPS savaş prototipinde animasyon, saldırı kombinasyonları, düşman AI ve hasar sistemlerinin birlikte çalışması gerekiyordu.",
        en: "The TPS combat prototype needed animation, attack combos, enemy AI, and damage systems to work together coherently."
      },
      solution: {
        tr: "Temel savaş mantığını C++ ile kurup Blueprint tarafında ayarlanabilir hale getirdim; animasyon ve gameplay olaylarını ayrıştırarak genişletilebilir bir yapı oluşturdum.",
        en: "I implemented the core combat logic in C++ and exposed adjustable behavior to Blueprint, separating animation and gameplay events for extensibility."
      },
      impact: {
        tr: "Kaynak kodu paylaşılabilir, incelenebilir bir UE5 C++ prototipi ortaya çıktı; teknik yetkinliği görsel demodan daha güçlü kanıtlıyor.",
        en: "The result is a shareable UE5 C++ prototype with source code, giving stronger technical proof than a visual demo alone."
      }
    },
    videoUrl: "https://www.youtube.com/embed/G8GVK_vpQWk",
    details: {
      geliştirmeSüresi: {
        tr: "2 ay",
        en: "2 months"
      },
      platform: "PC",
      durumu: {
        tr: "Tamamlandı",
        en: "Completed"
      },
      ekipBüyüklüğü: {
        tr: "1 kişi",
        en: "1 person"
      },
      roller: {
        tr: ["Oyun Tasarımı", "Programlama", "C++", "Blueprint", "Geliştirme"],
        en: ["Game Design", "Programming", "C++", "Blueprint", "Development"]
      },
      özellikler: {
        tr: [
          "TPS karakter kontrolü",
          "Saldırı kombinasyonları",
          "Düşman AI ve hasar sistemi",
          "Animasyon ve Blueprint entegrasyonu"
        ],
        en: [
          "TPS character control",
          "Attack combos",
          "Enemy AI and damage system",
          "Animation and Blueprint integration"
        ]
      }
    },
    gameUrl: "https://github.com/IRUNBOSS/CharacterPrepsCpp",
    gameUrlLabel: { tr: "Kaynak Kodları", en: "Source Code" }
  },
  {
    id: 14,
    title: {
      tr: "S.O.V: Passenger 23",
      en: "S.O.V: Passenger 23"
    },
    description: {
      tr: "Unity ile geliştirilen birinci şahıs psikolojik korku oyunu.",
      en: "A first-person psychological horror game developed with Unity."
    },
    image: "/images/Passenger23/header.jpg",
    date: "2025-03-13",
    technologies: ["Unity", "C#", "Horror", "FPS", "Retro Graphics", "Steam"],
    gallery: [
      "/images/Passenger23/ss_83808af918be2a33095ab550a56e7.jpg",
      "/images/Passenger23/ss_ea8a4dd23aa77023307294754522b.jpg",
      "/images/Passenger23/ss_bd6bc36296662492eed9cf4df3ff6.jpg",
      "/images/Passenger23/ss_7a172bc7ad30498f2b05dc084a9c0.jpg",
      "/images/Passenger23/ss_85368bbf7eed138dcdba26de65cc7.jpg",
      "/images/Passenger23/ss_79c50244ef0126999696f2404ce09.jpg",
      "/images/Passenger23/ss_b373ee463b5290b4cbfbdc79692eb.jpg",
      "/images/Passenger23/ss_c69bbc92070afd4adb1684a06c07c.jpg",
      "/images/Passenger23/ss_43e96dbacf16d4e7951b8674d2597.jpg",
      "/images/Passenger23/ss_ab0ede52f3926cb7738003c7d07d1.jpg",
      "/images/Passenger23/ss_495c85051a4b16cefb773c0cc95a9.jpg",
      "/images/Passenger23/ss_948806a71b1e675c2e3606a74c3e6.jpg"
    ],
    longDescription: {
      tr: `S.O.V: Passenger 23, IGNUS NEX ENTERTAINMENT bünyesinde Unity oyun motoruyla geliştirdiğimiz birinci şahıs bakış açısına sahip (FPS) psikolojik korku oyunudur. Karanlık atmosfer tasarımı, retro grafik stili (PS1 estetiği), olay tabanlı tetikleyici sistemler, ışıklandırma optimizasyonları ve oyunun anlatım gücünü destekleyen çevresel ipuçları ile gerçek olaylardan ilham alan senaryo öğelerini oyun içine başarıyla entegre ettik. Geliştirme sürecinin yanı sıra, oyunun test aşamalarında aktif rol aldım; hata ayıklama, oynanış geri bildirimlerinin değerlendirilmesi ve iyileştirme süreçlerinde görev aldım. Ayrıca, Steam yayını öncesi tanıtım görselleri, fragman planlaması, açıklama metinleri ve içerik pazarlaması gibi alanlarda da destek sağlayarak oyunun yayınlanma sürecine doğrudan katkıda bulundum.`,
      en: `S.O.V: Passenger 23 is a first-person psychological horror game developed with Unity under IGNUS NEX ENTERTAINMENT. The project features dark atmosphere design, retro graphics (PS1 aesthetics), event-based trigger systems, lighting optimizations, and environmental clues supporting the narrative, all inspired by real events. In addition to development, I actively participated in testing, debugging, evaluating gameplay feedback, and improvement processes. I also contributed to the game's release by supporting promotional visuals, trailer planning, description texts, and content marketing before the Steam launch.`
    },
    caseStudy: {
      problem: {
        tr: "Psikolojik korku deneyiminde atmosfer, tetikleyici olaylar, çevresel anlatım ve performansın aynı anda dengelenmesi gerekiyordu.",
        en: "The psychological horror experience needed to balance atmosphere, triggered events, environmental storytelling, and performance at the same time."
      },
      solution: {
        tr: "Unity içinde olay tabanlı tetikleyiciler, ışıklandırma düzenlemeleri, test geri bildirimleri ve Steam öncesi içerik hazırlıkları üzerinde çalıştım.",
        en: "I worked on event-based triggers, lighting adjustments, playtest feedback, and pre-Steam release content preparation in Unity."
      },
      impact: {
        tr: "Proje Steam'de yayınlandı; geliştirme, test, optimizasyon ve yayın hazırlığı süreçlerinde uçtan uca üretim deneyimi kazandım.",
        en: "The game was released on Steam, giving me end-to-end production experience across development, testing, optimization, and release preparation."
      }
    },
    videoUrl: "https://www.youtube.com/embed/lr8oEKG220s",
    extraVideos: [
      { label: { tr: "Oynanış Videosu", en: "Gameplay Video" }, url: "https://www.youtube.com/embed/RWdDsfJSLec" }
    ],
    details: {
      geliştirmeSüresi: {
        tr: "8 ay",
        en: "8 months"
      },
      platform: "PC",
      durumu: {
        tr: "Yayında",
        en: "Released"
      },
      ekipBüyüklüğü: {
        tr: "6 kişi",
        en: "6 people"
      },
      roller: {
        tr: ["Oyun Tasarımı", "Programlama", "Test ve Optimizasyon", "Tanıtım ve Yayın Süreci"],
        en: ["Game Design", "Programming", "Testing & Optimization", "Promotion & Release"]
      },
      özellikler: {
        tr: [
          "Karanlık atmosfer ve retro grafikler",
          "Olay tabanlı tetikleyici sistemler",
          "Işıklandırma ve optimizasyon",
          "Steam yayını ve içerik pazarlama"
        ],
        en: [
          "Dark atmosphere and retro graphics",
          "Event-based trigger systems",
          "Lighting and optimization",
          "Steam release and content marketing"
        ]
      }
    },
    gameUrl: "https://store.steampowered.com/app/2369810/SOV_Passenger_23/",
    gameUrlLabel: { tr: "Oyunu Oyna (Steam)", en: "Play on Steam" }
  },
  {
    id: 15,
    title: {
      tr: "Horizon Journey",
      en: "Horizon Journey"
    },
    description: {
      tr: "Unreal Engine 5 ile geliştirilen, Mars'ta geçen açık dünya co-op hayatta kalma oyunu.",
      en: "An open-world co-op survival game set on Mars, developed with Unreal Engine 5."
    },
    image: "/images/HorizonJourney/header.jpg",
    date: "2026-05-01",
    technologies: ["Unreal Engine 5", "C++", "Blueprints", "Behavior Trees", "AI Perception", "Control Rig", "Physics Assets"],
    longDescription: {
      tr: "Resemblance Interactive bünyesinde Horizon Journey'nin oynanış sistemlerini C++ ve Blueprints ile geliştirdim. Oyuncu etkileşimleri, araç mekanikleri, animasyon durum makineleri ve düşman yapay zekâsı üzerinde çalıştım. Mars rover ve UAV oynanışını; Physics Assets, Control Rig, animasyonlar ve araca özel etkileşim mantığını bir araya getirerek uyguladım. Behavior Trees ve AI Perception kullanarak üç farklı düşman arketipi için bir yapay zekâ altyapısı oluşturdum. Ayrıca derleme hataları, eklenti bağımlılığı çakışmaları, karakter kodlama sorunları ve platforma özgü derleme problemlerini çözdüm.",
      en: "At Resemblance Interactive, I developed Horizon Journey's gameplay systems using C++ and Blueprints. My work covered player interactions, vehicle mechanics, animation state machines, and enemy AI. I implemented Mars rover and UAV gameplay by integrating Physics Assets, Control Rig, animation, and vehicle-specific interaction logic. I built an AI framework for three distinct enemy archetypes using Behavior Trees and AI Perception, and resolved build failures, plugin dependency conflicts, encoding issues, and platform-specific compilation errors."
    },
    caseStudy: {
      problem: {
        tr: "Mars'ta geçen co-op hayatta kalma deneyimi; oyuncu etkileşimlerini, farklı araçların kontrol ve animasyonlarını ve farklı düşman davranışlarını bir araya getiriyordu.",
        en: "The co-op survival experience on Mars brought together player interactions, distinct vehicle controls and animations, and varied enemy behaviors."
      },
      solution: {
        tr: "C++ ve Blueprints ile oynanış sistemleri geliştirdim; rover ve UAV mekaniklerini fizik ve animasyon bileşenleriyle bütünleştirdim. Düşman davranışlarını Behavior Trees ve AI Perception üzerinden yapılandırdım.",
        en: "I developed gameplay systems in C++ and Blueprints, integrated rover and UAV mechanics with physics and animation components, and structured enemy behaviors with Behavior Trees and AI Perception."
      },
      impact: {
        tr: "Steam'de yayınlanan projeye araç oynanışı, oyuncu etkileşimleri ve üç düşman arketipini kapsayan yapay zekâ altyapısıyla katkı sağladım; üretim sürecindeki derleme ve bağımlılık sorunlarını giderdim.",
        en: "I contributed vehicle gameplay, player interactions, and an AI framework covering three enemy archetypes to the Steam-released project, while resolving production build and dependency issues."
      }
    },
    details: {
      contributionPeriod: { tr: "Kas 2025 – Mar 2026", en: "Nov 2025 – Mar 2026" },
      platform: "PC",
      durumu: { tr: "Steam'de Yayında", en: "Released on Steam" },
      roller: {
        tr: ["Oynanış Programlama", "Araç Sistemleri", "Düşman Yapay Zekâsı", "Derleme Sorunlarının Çözümü"],
        en: ["Gameplay Programming", "Vehicle Systems", "Enemy AI", "Build Troubleshooting"]
      },
      özellikler: {
        tr: ["Mars'ta açık dünya co-op hayatta kalma", "Oyuncu etkileşimleri ve animasyon durum makineleri", "Mars rover ve UAV oynanışı", "Physics Assets ve Control Rig entegrasyonu", "Üç düşman arketipi için Behavior Trees ve AI Perception"],
        en: ["Open-world co-op survival on Mars", "Player interactions and animation state machines", "Mars rover and UAV gameplay", "Physics Assets and Control Rig integration", "Behavior Trees and AI Perception for three enemy archetypes"]
      }
    },
    gallery: [
      "/images/HorizonJourney/screenshot-0.jpg",
      "/images/HorizonJourney/screenshot-1.jpg",
      "/images/HorizonJourney/screenshot-2.jpg",
      "/images/HorizonJourney/screenshot-3.jpg",
      "/images/HorizonJourney/screenshot-4.jpg",
      "/images/HorizonJourney/screenshot-5.jpg",
      "/images/HorizonJourney/screenshot-6.jpg",
      "/images/HorizonJourney/screenshot-7.jpg",
      "/images/HorizonJourney/screenshot-8.jpg",
      "/images/HorizonJourney/screenshot-9.jpg",
      "/images/HorizonJourney/screenshot-10.jpg",
      "/images/HorizonJourney/screenshot-11.jpg",
      "/images/HorizonJourney/screenshot-12.jpg"
    ],
    videoUrl: "https://video.akamai.steamstatic.com/store_trailers/1769960/874466/b08c79a248198b0e1d784e600b5bd233b26b45bb/1751029076/hls_264_master.m3u8?t=1745231040",
    videoType: "hls",
    videoPoster: "/images/HorizonJourney/trailer-0.jpg",
    extraVideos: [
      {
        "label": "Announcement Trailer",
        "url": "https://video.akamai.steamstatic.com/store_trailers/1769960/666205/b69ffc7ff84ed077925d904bbc43f67e8bda9d50/1751029075/hls_264_master.m3u8?t=1728621525",
        "type": "hls",
        "poster": "/images/HorizonJourney/trailer-1.jpg"
      }
    ],
    gameUrl: "https://store.steampowered.com/app/1769960/",
    gameUrlLabel: {
      "tr": "Steam'de Gör",
      "en": "View on Steam"
    }
  },
  {
    id: 16,
    title: {
      tr: "V.A.U.L.T. Protocol",
      en: "V.A.U.L.T. Protocol"
    },
    description: {
      tr: "Unity ile geliştirilen, 6 oyunculu co-op korku oyunu. Steam'de erken erişimde.",
      en: "A 6-player co-op horror game developed with Unity, available in Steam Early Access."
    },
    image: "/images/VaultProtocol/header.jpg",
    date: "2026-08-21",
    technologies: ["Unity", "C#", "FishNet", "Steamworks", "Dissonance", "Spatial Audio"],
    longDescription: {
      tr: "IGNUS NEX ENTERTAINMENT bünyesinde V.A.U.L.T. Protocol'ün çok oyunculu oynanış sistemlerini Unity, FishNet ve Steamworks ile geliştirdim. Ağ üzerinden çalışan oyuncu etkileşimleri, envanter ve ganimet yönetimi, özelleştirme sistemleri ve menü akışları üzerinde çalıştım. Dissonance tabanlı üç boyutlu yakınlık sohbeti ve telsiz üzerinden bas-konuş iletişimini uyguladım; ayrı ses kanalları, konumsal ses ve kanala özel ses işleme özelliklerini bir araya getirdim. Proje, altı oyuncunun birlikte oynayabildiği bir co-op korku deneyimi olarak Steam erken erişiminde yer alıyor.",
      en: "At IGNUS NEX ENTERTAINMENT, I developed V.A.U.L.T. Protocol's multiplayer gameplay systems with Unity, FishNet, and Steamworks. My work included networked player interactions, inventory and loot handling, customization systems, and menu flows. I implemented Dissonance-based 3D proximity voice and radio push-to-talk communication, combining separate voice channels, spatial audio, and channel-specific voice processing. The project is a six-player co-op horror experience available in Steam Early Access."
    },
    caseStudy: {
      problem: {
        tr: "Altı oyunculu co-op korku deneyimi, ağ üzerinden çalışan etkileşim ve envanter sistemlerinin yanı sıra yakınlık sohbeti ile telsiz iletişimini ayrı kanallarda sunmayı gerektiriyordu.",
        en: "The six-player co-op horror experience required networked interactions and inventory systems, alongside proximity voice and radio communication on separate channels."
      },
      solution: {
        tr: "Unity, FishNet ve Steamworks ile çok oyunculu etkileşim, ganimet, özelleştirme ve menü sistemlerini geliştirdim. Dissonance ile konumsal yakınlık sohbetini ve bas-konuş telsiz iletişimini ayrı ses kanalları ve kanala özel işleme ile uyguladım.",
        en: "I developed multiplayer interaction, loot, customization, and menu systems using Unity, FishNet, and Steamworks. With Dissonance, I implemented spatial proximity voice and push-to-talk radio communication using separate channels and channel-specific processing."
      },
      impact: {
        tr: "Steam erken erişimindeki projeye çok oyunculu etkileşimler, envanter ve ganimet akışları ile iki farklı iletişim biçimini destekleyen ses sistemleri kazandırdım.",
        en: "I contributed networked interactions, inventory and loot flows, and voice systems supporting two distinct communication modes to the Steam Early Access project."
      }
    },
    details: {
      platform: "PC",
      durumu: { tr: "Erken Erişim", en: "Early Access" },
      roller: {
        tr: ["Çok Oyunculu Oynanış", "Ağ Programlama", "Envanter ve Ganimet", "Sesli İletişim"],
        en: ["Multiplayer Gameplay", "Network Programming", "Inventory & Loot", "Voice Communication"]
      },
      özellikler: {
        tr: ["6 oyunculu co-op korku deneyimi", "FishNet ve Steamworks ile çok oyunculu sistemler", "Ağ üzerinden oyuncu etkileşimleri ve envanter/ganimet yönetimi", "Özelleştirme sistemleri ve menü akışları", "Dissonance tabanlı 3D yakınlık sohbeti", "Ayrı kanallarda bas-konuş telsiz ve kanala özel ses işleme"],
        en: ["6-player co-op horror experience", "Multiplayer systems with FishNet and Steamworks", "Networked player interactions and inventory/loot handling", "Customization systems and menu flows", "Dissonance-based 3D proximity voice", "Separate push-to-talk radio channels and channel-specific voice processing"]
      }
    },
    gallery: [
      "/images/VaultProtocol/screenshot-0.jpg",
      "/images/VaultProtocol/screenshot-1.jpg",
      "/images/VaultProtocol/screenshot-2.jpg",
      "/images/VaultProtocol/screenshot-3.jpg",
      "/images/VaultProtocol/screenshot-4.jpg",
      "/images/VaultProtocol/screenshot-5.jpg",
      "/images/VaultProtocol/screenshot-6.jpg",
      "/images/VaultProtocol/screenshot-7.jpg",
      "/images/VaultProtocol/screenshot-8.jpg",
      "/images/VaultProtocol/screenshot-9.jpg",
      "/images/VaultProtocol/screenshot-10.jpg",
      "/images/VaultProtocol/screenshot-11.jpg",
      "/images/VaultProtocol/screenshot-12.jpg",
      "/images/VaultProtocol/screenshot-13.jpg",
      "/images/VaultProtocol/screenshot-14.jpg",
      "/images/VaultProtocol/screenshot-15.jpg"
    ],
    videoUrl: "https://video.akamai.steamstatic.com/store_trailers/4178200/1601344659/f5c5b0620eb7dda6897bf9cf12bd2ebb0375b979/1787321053/hls_264_master.m3u8?t=1787321671",
    videoType: "hls",
    videoPoster: "/images/VaultProtocol/trailer-0.jpg",
    extraVideos: [
      {
        "label": "V.A.U.L.T PROTOCOL OFFICIAL TRAILER",
        "url": "https://video.akamai.steamstatic.com/store_trailers/4178200/1281620367/79d6c41508cbda5e1c555f1e423b426fbc7d8ac6/1779659494/hls_264_master.m3u8?t=1779660561",
        "type": "hls",
        "poster": "/images/VaultProtocol/trailer-1.jpg"
      }
    ],
    gameUrl: "https://store.steampowered.com/app/4178200/",
    gameUrlLabel: {
      "tr": "Steam'de Gör",
      "en": "View on Steam"
    }
  },
  /* {
    id: 4,
    title: "Racing Fever",
    description: "Unreal Engine ile geliştirilmiş yarış oyunu. Gerçekçi fizik motoru",
    image: "/images/racing-game.jpg",
    technologies: ["Unreal Engine", "C++", "Physics"],
    gallery: [
      "/images/racing-game/1.jpg",
      "/images/racing-game/2.jpg",
      "/images/racing-game/3.jpg",
      "/images/racing-game/4.jpg"
    ],
    longDescription: "Racing Fever, gerçekçi fizik motoru ile tasarlanmış bir yarış oyunudur. Oyuncular, farklı araçları kullanarak yarışları yaparken hız ve performansı optimize ederler.",
    videoUrl: "https://www.youtube.com/embed/VIDEO_ID_4",
    details: {
      geliştirmeSüresi: "5 ay",
      platform: "PC",
      durumu: "Tamamlandı",
      ekipBüyüklüğü: "3 kişi",
      roller: ["Oyun Tasarımı", "Programlama", "Fizik"],
      özellikler: [
        "Çoklu oyuncu desteği",
        "Kaydetme sistemi",
        "Başarım sistemi",
        "Özelleştirilebilir araçlar"
      ]
    },
    gameUrl: "https://store.steampowered.com/app/XXXX/Game_Name"
  },
  {
    id: 5,
    title: "Survival Island",
    description: "Unity ile geliştirilmiş hayatta kalma oyunu. Açık dünya macerası",
    image: "/images/survival-game.jpg",
    technologies: ["Unity", "C#", "AI"],
    gallery: [
      "/images/survival-game/1.jpg",
      "/images/survival-game/2.jpg",
      "/images/survival-game/3.jpg",
      "/images/survival-game/4.jpg"
    ],
    longDescription: "Survival Island, açık dünya macerası olarak tasarlanmış bir hayatta kalma oyunudur. Oyuncular, çeşitli zorluklarla karşılaşırken hayatta kalmayı amaçlar.",
    videoUrl: "https://www.youtube.com/embed/VIDEO_ID_5",
    details: {
      geliştirmeSüresi: "7 ay",
      platform: "PC, Mobile",
      durumu: "Devam ediyor",
      ekipBüyüklüğü: "4 kişi",
      roller: ["Oyun Tasarımı", "Programlama", "Yapay Zeka"],
      özellikler: [
        "Çoklu oyuncu desteği",
        "Kaydetme sistemi",
        "Başarım sistemi",
        "Özelleştirilebilir karakterler"
      ]
    },
    gameUrl: "https://store.steampowered.com/app/XXXX/Game_Name"
  },
  {
    id: 6,
    title: "Medieval Wars",
    description: "Unreal Engine ile geliştirilmiş strateji oyunu. Krallıklar arası savaş",
    image: "/images/strategy-game.jpg",
    technologies: ["Unreal Engine", "C++", "Multiplayer"],
    gallery: [
      "/images/strategy-game/1.jpg",
      "/images/strategy-game/2.jpg",
      "/images/strategy-game/3.jpg",
      "/images/strategy-game/4.jpg"
    ],
    longDescription: "Medieval Wars, krallıklar arası savaşı simüle eden bir strateji oyunudur. Oyuncular, farklı krallıkları kontrol ederken stratejiler geliştirirler.",
    videoUrl: "https://www.youtube.com/embed/VIDEO_ID_6",
    details: {
      geliştirmeSüresi: "9 ay",
      platform: "PC",
      durumu: "Tamamlandı",
      ekipBüyüklüğü: "5 kişi",
      roller: ["Oyun Tasarımı", "Programlama", "Çoklu Oyuncu"],
      özellikler: [
        "Çoklu oyuncu desteği",
        "Kaydetme sistemi",
        "Başarım sistemi",
        "Özelleştirilebilir krallıklar"
      ]
    },
    gameUrl: "https://store.steampowered.com/app/XXXX/Game_Name"
  },
  {
    id: 7,
    title: "Zombie Defense",
    description: "Unity ile geliştirilmiş tower defense oyunu. Zombi istilasına karşı savunma",
    image: "/images/zombie-game.jpg",
    technologies: ["Unity", "C#", "Pathfinding"],
    gallery: [
      "/images/zombie-game/1.jpg",
      "/images/zombie-game/2.jpg",
      "/images/zombie-game/3.jpg",
      "/images/zombie-game/4.jpg"
    ],
    longDescription: "Zombie Defense, zombi istilasına karşı savunma olarak tasarlanmış bir tower defense oyunudur. Oyuncular, zombileri engellemek ve koruma için çeşitli savunma yapıları inşa ederler.",
    videoUrl: "https://www.youtube.com/embed/VIDEO_ID_7",
    details: {
      geliştirmeSüresi: "8 ay",
      platform: "PC, Mobile",
      durumu: "Devam ediyor",
      ekipBüyüklüğü: "3 kişi",
      roller: ["Oyun Tasarımı", "Programlama", "Yol Bulma"],
      özellikler: [
        "Çoklu oyuncu desteği",
        "Kaydetme sistemi",
        "Başarım sistemi",
        "Özelleştirilebilir zombiler"
      ]
    },
    gameUrl: "https://store.steampowered.com/app/XXXX/Game_Name"
  },
  {
    id: 8,
    title: "Sports League",
    description: "Unreal Engine ile geliştirilmiş spor simülasyonu. Gerçekçi fizik ve animasyonlar",
    image: "/images/sports-game.jpg",
    technologies: ["Unreal Engine", "C++", "Animation"],
    gallery: [
      "/images/sports-game/1.jpg",
      "/images/sports-game/2.jpg",
      "/images/sports-game/3.jpg",
      "/images/sports-game/4.jpg"
    ],
    longDescription: "Sports League, gerçekçi fizik ve animasyonlarla tasarlanmış bir spor simülasyonu oyunudur. Oyuncular, farklı sporları simüle ederken fizik ve animasyon becerilerini geliştirirler.",
    videoUrl: "https://www.youtube.com/embed/VIDEO_ID_8",
    details: {
      geliştirmeSüresi: "7 ay",
      platform: "PC",
      durumu: "Tamamlandı",
      ekipBüyüklüğü: "4 kişi",
      roller: ["Oyun Tasarımı", "Programlama", "Animasyon"],
      özellikler: [
        "Çoklu oyuncu desteği",
        "Kaydetme sistemi",
        "Başarım sistemi",
        "Özelleştirilebilir sporlar"
      ]
    },
    gameUrl: "https://store.steampowered.com/app/XXXX/Game_Name"
  },
  {
    id: 9,
    title: "City Builder",
    description: "Unity ile geliştirilmiş şehir inşa etme oyunu. Ekonomi ve kaynak yönetimi",
    image: "/images/city-game.jpg",
    technologies: ["Unity", "C#", "Economy System"],
    gallery: [
      "/images/city-game/1.jpg",
      "/images/city-game/2.jpg",
      "/images/city-game/3.jpg",
      "/images/city-game/4.jpg"
    ],
    longDescription: "City Builder, ekonomi ve kaynak yönetimi için tasarlanmış bir şehir inşa etme oyunudur. Oyuncular, şehirlerini inşa ederken ekonomi ve kaynak yönetimi hakkında bilgi edinirler.",
    videoUrl: "https://www.youtube.com/embed/VIDEO_ID_9",
    details: {
      geliştirmeSüresi: "10 ay",
      platform: "PC",
      durumu: "Tamamlandı",
      ekipBüyüklüğü: "5 kişi",
      roller: ["Oyun Tasarımı", "Programlama", "Ekonomi"],
      özellikler: [
        "Çoklu oyuncu desteği",
        "Kaydetme sistemi",
        "Başarım sistemi",
        "Özelleştirilebilir şehirler"
      ]
    },
    gameUrl: "https://store.steampowered.com/app/XXXX/Game_Name"
  },
  {
    id: 10,
    title: "VR Experience",
    description: "Unreal Engine ile geliştirilmiş sanal gerçeklik deneyimi. İnteraktif ortam",
    image: "/images/vr-game.jpg",
    technologies: ["Unreal Engine", "C++", "VR"],
    gallery: [
      "/images/vr-game/1.jpg",
      "/images/vr-game/2.jpg",
      "/images/vr-game/3.jpg",
      "/images/vr-game/4.jpg"
    ],
    longDescription: "VR Experience, sanal gerçeklik deneyimi olarak tasarlanmış bir oyunudur. Oyuncular, sanal ortamda interaktif deneyimler yaşarlar.",
    videoUrl: "https://www.youtube.com/embed/VIDEO_ID_10",
    details: {
      geliştirmeSüresi: "8 ay",
      platform: "PC, Mobile",
      durumu: "Tamamlandı",
      ekipBüyüklüğü: "3 kişi",
      roller: ["Oyun Tasarımı", "Programlama", "VR"],
      özellikler: [
        "Çoklu oyuncu desteği",
        "Kaydetme sistemi",
        "Başarım sistemi",
        "Özelleştirilebilir sanal gerçeklik"
      ]
    },
    gameUrl: "https://store.steampowered.com/app/XXXX/Game_Name"
  }*/
]; 
